/**
 * Enable/disable a button and add a loader animation on it
 *
 * @param {JQuery} button
 * @param {boolean} isEnabled
 */
export function toggleButtonState(button : JQuery, isEnabled : boolean) : void {
    const domButton = button[0] as HTMLButtonElement;
    if (domButton) {
        domButton.disabled = !isEnabled;
        domButton.classList.toggle('disabled', !isEnabled);
        domButton.classList.toggle('button-loading', !isEnabled);
    }
}
